import Box from "../../../shared/box/Box";
import {
  useGetOutlookCredentialsQuery,
  useOutlookLogoutMutation
} from "../../../store/google-reservations/googleReservationsApi";
import { useGetOutlookAuthUrlQuery, useGetXeroAuthUrlQuery } from "../../../store/reservations/reservationsApi";
import { useGetXeroCredentialsQuery, useLogoutXeroMutation } from "../../../store/xero-integration/xeroApi";
import Button from "../../../shared/button";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigation = useNavigate();
  const { data: outlookAuthUrl } = useGetOutlookAuthUrlQuery({});
  const { data: outlookCredentials, isLoading } = useGetOutlookCredentialsQuery();
  const [logoutOutlook] = useOutlookLogoutMutation()
  const { data: xeroAuthUrl } = useGetXeroAuthUrlQuery({});
  const [logoutXero] = useLogoutXeroMutation();

  const handleOutlookAuth = () => {
    window.location.assign(outlookAuthUrl.authUrl);
  };

  const handleXeroAuth = () => {
    window.location.assign(xeroAuthUrl.authUrl);
  };

  const handleOutlookLogout = async () => {
    try {
      await logoutOutlook().unwrap();
      localStorage.removeItem('googleAccessToken');
      localStorage.removeItem('googleRefreshToken')
    } catch (e) {
      console.log({ e })
    }
  };

  const handleXeroLogout = async () => {
    try {
      // await logoutXero().unwrap();
      localStorage.removeItem('xeroAccessToken');
      localStorage.removeItem('xeroRefreshToken');
    } catch (e) {
      console.log({ e })
    }
  };

  const onClickIntegrations = () => {
    navigation('/settings/integrations')
  }

  return (
    <div>
      <h4 className="page-title">Settings</h4>
      <div className="flex flex-wrap my-8 -mx-2">
        <div className="w-full md:w-6/12 px-2">
          <Box title="Outlook Login">
            {isLoading ? (
              <p className="text-sm">Loading...</p>
            ) : outlookCredentials?.accessToken ? (
              <>
                <p> You are already logged in </p>
                <Button
                  type="button"
                  label={"Logout from outlook"}
                  onClickButton={handleOutlookLogout}
                />
              </>
            ) : (
              <Button
                type="button"
                label={"Login"}
                onClickButton={handleOutlookAuth}
              />
            )}
          </Box>
        </div>
        <div className="w-full md:w-6/12 px-2">
          <Box title="Stripe payment">Pay here</Box>
        </div>
        <div className="w-full md:w-6/12 px-2">
          <Box title="Xero Login">
            {isLoading ? (
              <p className="text-sm">Loading...</p>
            ) : localStorage.getItem('xeroAccessToken') ? (
              <>
                <p> You are already logged in </p>
                <Button
                  type="button"
                  label={"Logout from xero"}
                  onClickButton={handleXeroLogout}
                />
              </>
            ) : (
              <Button
                type="button"
                label={"Login"}
                onClickButton={handleXeroAuth}
              />
            )}
          </Box>
        </div>
        <div className="w-full md:w-6/12 px-2">
          <Box title="Integrations">
            <div>
              <Button
                label={'Integrations List'}
                className="btn-primary-rounded-less"
                onClickButton={onClickIntegrations}
              />
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Settings;
